import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComment = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.2 4.5H14.8C15.46 4.5 16 5.04 16 5.7V15.2929C16 15.7383 15.4614 15.9614 15.1464 15.6464L13.8929 14.3929C13.7054 14.2054 13.451 14.1 13.1858 14.1H5.2C4.54 14.1 4 13.56 4 12.9V5.7C4 5.04 4.54 4.5 5.2 4.5ZM13.1381 8.13807C13.3984 7.87772 13.3984 7.45561 13.1381 7.19526C12.8777 6.93491 12.4556 6.93491 12.1953 7.19526L9.66667 9.72386L8.13807 8.19526C7.87772 7.93491 7.45561 7.93491 7.19526 8.19526C6.93491 8.45561 6.93491 8.87772 7.19526 9.13807L9.19526 11.1381C9.45561 11.3984 9.87772 11.3984 10.1381 11.1381L13.1381 8.13807Z",
		fill: "#5CDBD3"
	})
});
const ForwardRef = forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
